module.exports = __webpack_public_path__ + "static/media/money_pig.0d76ba3a.png";